import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { registerUser } from '../../actions'
import { defaultFahrerMail } from '../../constants'


class RegisterPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            user: {
                firstName: '',
                lastName: '',
                username: '',
                email: '',
                password: '',
                kdnummer: '',
                roles: ['fuhrparkleiter'],
                fahrerMail: defaultFahrerMail
            },
            submitted: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.checkValue = this.checkValue.bind(this);
    }

    handleChange(event) {
        const { name, value } = event.target;
        console.log("name:", name, " ,value:", value);
        const { user } = this.state;
        this.setState({
            user: {
                ...user,
                [name]: value
            }
        });
    }

    checkValue(s) {
      console.log(s);
      return this.state.user.roles.indexOf(s) > -1
    }

    handleSubmit(event) {
        event.preventDefault();

        this.setState({ submitted: true });
        const { user } = this.state;
        //const { dispatch } = this.props;
        if (user.firstName && user.lastName && user.username && user.password && user.password.length > 5) {
            console.log("registerUser wird ausgeführt");
            this.props.registerUser( user, this.props.history );
            //dispatch(userActions.register(user));
        }
    }

    render() {
        const { registering  } = this.props;
        const { user, submitted } = this.state;
        return (
            <div className="col-md-6 col-md-offset-3">
                <h2>Neuen User anlegen</h2>
                <form name="form" onSubmit={this.handleSubmit}>
                    <div className={'form-group' + (submitted && !user.firstName ? ' has-error' : '')}>
                        <label htmlFor="firstName">Vorname</label>
                        <input type="text" className="form-control" name="firstName" value={user.firstName} onChange={this.handleChange} />
                        {submitted && !user.firstName &&
                            <div className="help-block">First Name is required</div>
                        }
                    </div>
                    <div className={'form-group' + (submitted && !user.lastName ? ' has-error' : '')}>
                        <label htmlFor="lastName">Nachname</label>
                        <input type="text" className="form-control" name="lastName" value={user.lastName} onChange={this.handleChange} />
                        {submitted && !user.lastName &&
                            <div className="help-block">Last Name is required</div>
                        }
                    </div>
                    <div className={'form-group' + (submitted && !user.username ? ' has-error' : '')}>
                        <label htmlFor="username">Username</label>
                        <input type="text" className="form-control" name="username" value={user.username} onChange={this.handleChange} />
                        {submitted && !user.username &&
                            <div className="help-block">Username is required</div>
                        }
                    </div>
                    <div className={'form-group' + (submitted && !user.email ? ' has-error' : '')}>
                        <label htmlFor="username">Email</label>
                        <input type="text" className="form-control" name="email" value={user.email} onChange={this.handleChange} />
                        {submitted && !user.email &&
                            <div className="help-block">Email is required</div>
                        }
                    </div>
                    <div className={'form-group' + (submitted && !user.kdnummer ? ' has-error' : '')}>
                        <label htmlFor="username">Kundennummer</label>
                        <input type="text" className="form-control" name="kdnummer" value={user.kdnummer} onChange={this.handleChange} />
                        {submitted && !user.kdnummer &&
                            <div className="help-block">Kundennummer is required</div>
                        }
                    </div>
                    <div className={'form-group' + (submitted && !user.roles ? ' has-error' : '')}>
                        <label htmlFor="username">Rolle(n)</label>
                          <select name="roles" size="3" onChange={this.handleChange} multiple>
                            <option value="fuhrparkleiter" selected={this.checkValue('fuhrparkleiter')}>Fuhrparkleiter</option>
                            <option value="admin" selected={this.checkValue('admin')}>Admin</option>
                            <option value="demo" selected={this.checkValue('demo')}>Demo</option>
                          </select>
                        {submitted && !user.roles &&
                            <div className="help-block">Mindestens eine Rolle muss gewählt sein.</div>
                        }
                    </div>
                    <div className={'form-group' + (submitted && !user.password ? ' has-error' : '')}>
                        <label htmlFor="password">Passwort</label>
                        <input type="password" className="form-control" name="password" value={user.password} onChange={this.handleChange} />
                        {submitted && !user.password &&
                            <div className="help-block">Password is required</div>
                        }
                        {submitted && user.password && user.password.length < 6 &&
                            <div className="help-block">Das Passwort muss mindestens aus 6 Zeichen bestehen.</div>
                        }
                    </div>
                    <div className="form-group">
                      <Link to="/" style={{marginRight: '10px'}}>
                        <button className="btn btn-secondary">
                          <span style={{color: 'white'}}>Abbrechen</span>
                        </button>
                      </Link>
                        <button className="btn btn-default">Register</button>
                        {registering &&
                            <img alt="Register" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                        }

                    </div>
                </form>
            </div>
        );
    }
}

const mapDispatchToProps = {
	registerUser
}

/*
function mapStateToProps(state) {
    const { registering } = state.registration;
    return {
        registering
    };
}
*/

const connectedRegisterPage = connect(null, mapDispatchToProps)(RegisterPage);
export { connectedRegisterPage as RegisterPage };



// WEBPACK FOOTER //
// ./src/components/RegisterPage/RegisterPage.jsx